<div class="content">
  @if (errorMessage()) {
    <div class="errorMessage">
      {{ errorMessage() }}
    </div>
  }
  <div class="inputRow">
    <span class="inputLabel">Selected Extended Warranty:</span>
    <select [disabled]="changesDisabled()" class="inputField" [(ngModel)]="extendedWarrantyCode" (change)="updateSelection()">
      <option value="" label="None"></option>
      @for (factor of availableWarrantyCodes(); track factor) {
        <option [value]="factor.code">{{ factor.displayLabel }}</option>
      }
    </select>
  </div>
  <div class="displayRow">
    <span class="displayLabel">Estimated Price:</span>
    <span class="valueLabel">{{ estimatedPrice() | currency: 'USD' }}</span>
  </div>
  <div class="disclaimerRow">
    <span class="disclaimerLabel">
      <p>Should the extended warranty be selected, the extended warranty will begin after IEC’s standard limited warranty period ends.</p>
      <p>Please refer to IEC’s standard terms and conditions for more details.</p>
      <p>Extended Warranty is calculated based on the Net Amount at the published unit volume multiplier * Extended Warranty percentage</p>
    </span>
  </div>
  @if (warningMessage) {
    <div class="warningMessage">
      {{ warningMessage }}
    </div>
  }
  <div class="buttonRow">
    <span class="spacer"></span>
    <button [disabled]="isBusy()" matButton="elevated" (click)="cancel()" class="inputButton warn-button">
      <mat-icon class="size-12">cancel</mat-icon>
      <span>Cancel</span>
    </button>
    <button [disabled]="changesDisabled()" matButton="elevated" class="inputButton primary-button" (click)="save()">
      <mat-icon class="size-12">save</mat-icon>
      <span>Save</span>
    </button>
  </div>
</div>
